import React from "react";
import { Grid, Typography } from "@mui/material";



function MainDashboard() {
  return (
    <div>
      <Grid container spacing={3}>
        <Typography variant="h1" component="h2">
          Coming soon
        </Typography>
      </Grid>
    </div>
  );
}

export default MainDashboard;
